import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ILocationWide } from '../../Interfaces';
import { formattedDate, formattedDateTime } from '../../Helpers/TimeMethods';

export const ExportCSV = (csvData: ILocationWide[], page: 'standort' | 'freiplatz') => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const d  = new Date()

    const today = new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(d);

    const fileName = (page === 'standort') ? 'standorte' + today : 'freiplatzmeldungen' + today;// + fileExtension

    let Heading = [];
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    const xlData:any[] = []
    if(page === 'standort') {
        Heading = [['Leitzeichen', 'Name des Standortes', 'Standortkategorie', 'Bewohnergruppen', 'Bezirk', 'Adresse', 'Ansprechperson',
            'Telefonnummer', 'E-Mail', 'Belegungsstart', 'Belegungsende', 'Geschäftsbereich', 'TL', 'BL', 'Soll-Kapazität', 'Letzte Meldung vom'
        ]]

        csvData.map(x=> {
            return (
                xlData.push ( {
                    WNummer: x.wnummer,
                    Name: x.name,
                    Kategorie: x.locationCategory,
                    Bewohnergruppen: x.residentGroups,
                    Bezirk: x.district,
                    Addresse: x.address,
                    Ansprechperson: x.contactPerson,
                    Telefon: x.phoneNumber,
                    Email: x.email,
                    Belegungsstart: formattedDate(x.startOfOccupancy),
                    Belegungsende:  formattedDate(x.endOfOccupancy),
                    'Geschäftsbereich': x.businessDivision,
                    TL: x.tl,
                    BL: x.bl,
                    Capacity: x.capacity,
                    lastUpdate: formattedDateTime(x.lastUpdate)

                } )
            )
        })
    } else {
    Heading = [[
        'Leitzeichen', 'Name des Standortes', 'Standortkategorie', 'Bewohnergruppen', 'Bezirk', 'Adresse', 'Ansprechperson',
        'Telefonnummer', 'E-Mail', 'TL', 'BL', 'Belegungsstart', 'Belegungsende', 'Anzahl Ist-Belegung Ukrainer', 'Anzahl Ist-Belegung örU',
        'Anzahl belegbare Plätze', 
        'Anzahl reservierter Plätze',
        'Anzahl nicht belegbarer Plätze',
        'Warum nicht belegbar?',
        // 'Anzahl Einzelzimmer w',
        // 'Anzahl Einzelzimmer m',
        'Anzahl Einzelzimmer (w/m/d)',
        'Anmerkungen Einzelzimmer',
        'Anzahl Platz in bereits belegtem Zimmer w',
        'Anmerkungen zu einem bereits belegtem Zimmer w',
        'Anzahl Platz in bereits belegtem Zimmer m',
        'Anmerkungen zu einem bereits belegtem Zimmer m',
        'Anzahl 2er Zimmer',
        'Anmerkungen zur 2-Zimmer',
        'Anzahl 3er Zimmer',
        'Anmerkungen zur 3-Zimmer',
        'Anzahl 4er Zimmer',
        'Anmerkungen zur 4-Zimmer',
        'Anzahl 5er Zimmer',
        'Anmerkungen zur 5-Zimmer',
        'Anzahl 6er Zimmer',
        'Anmerkungen zur 6-Zimmer',
        'Anzahl 7er Zimmer',
        'Anmerkungen zur 7-Zimmer',
        'Anzahl 8er Zimmer',
        'Anmerkungen zur 8-Zimmer',
        'Anzahl 9er Zimmer',
        'Anmerkungen zur 9-Zimmer',
        'Anzahl 10er Zimmer',
        'Anmerkungen zur 10-Zimmer',
        'Belegungshinweise zu den Plätzen'
]];

csvData.map(x=> {
    return (
        xlData.push ( {
            WNummer: x.wnummer,
            Name: x.name,
            Kategorie: x.locationCategory,
            Bewohnergruppen: x.residentGroups,
            Bezirk: x.district,
            Addresse: x.address,
            Ansprechperson: x.contactPerson,
            Telefon: x.phoneNumber,
            Email: x.email,
            TL: x.tl,
            BL: x.bl,
            Belegungsstart: formattedDate(x.startOfOccupancy),
            Belegungsende:  formattedDate(x.endOfOccupancy),
            'Anzahl Ist-Belegung Ukrainer' : x.numberOfOccupiedUkr,
            'Anzahl Ist-Belegung örU': x.numberOfOccupiedOru,
            'Anzahl freie Plätze': x.numberOfAvailablePlaces,
            'Anzahl reservierter Plätze': x.numberOfReservedSeats,
            'Anzahl nicht belegbare Plätze': x.numberOfUnoccupiedSeats, 
            whyNotAssignable : x.whyNotAssignable,
            'Anzahl Einzelzimmer (w/m/d)':x.singleRoomFMD,
            'text_SingleRoomFMD' : x.text_SingleRoomFMD,
            'Anzahl Platz in bereits belegtem Zimmer w' : x.feedSlotW,
            'Anmerkungen zu einem bereits belegtem Zimmer w': x.text_FeedSlotW,
            'Anzahl Platz in bereits belegtem Zimmer m': x.feedSlotM,
            'Anmerkungen zu einem bereits belegtem Zimmer m': x.text_FeedSlotM,
            '2er' : x.roomForTwo,
            'Anmerkungen zur 2-Zimmer': x.text_RoomForTwo,
            '3er' :x.roomForThree,
            'Anmerkungen zur 3-Zimmer': x.text_RoomForThree,
            '4er': x.roomForFour,
            'Anmerkungen zur 4-Zimmer': x.text_RoomForFour,
            '5er': x.roomForFive,
            'Anmerkungen zur 5-Zimmer': x.text_RoomForFive,
            '6er': x.roomForSix,
            'Anmerkungen zur 6-Zimmer': x.text_RoomForSix,
            '7er': x.roomForSeven,
            'Anmerkungen zur 7-Zimmer': x.text_RoomForSeven,
            '8er' : x.roomForEight,
            'Anmerkungen zur 8-Zimmer': x.text_RoomForEight,
            '9er' : x.roomForNine,
            'Anmerkungen zur 9-Zimmer': x.text_RoomForNine,
            '10er': x.roomForTen,
            'Anmerkungen zur 10-Zimmer': x.text_RoomForTen,
            'Belegungshinweise zu den Plätzen': x.notesOnAccommodation

        } )
    )
})
}




        const wb = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(ws, Heading, {cellStyles: true });

        //ws['!margins'] = [ { top: 1, left: 1}]
        XLSX.utils.sheet_add_json(ws, xlData, { origin: 'A2', skipHeader: true });

        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const max_width = xlData.reduce((w, r) => Math.max(w, r.Name.length), 7);

        if(page === 'standort') {
        //                Leitzeichen        Name 	    Standortkategorie   Bewohnergruppen  Bezirk     Adresse   Ansprechperson	Telefonnummer	E-Mail	Belegungsstart	Belegungsende	Geschäftsbereich	TL      	BL	Soll-Kapazität  	Letzte Meldung vom
        ws["!cols"] = [ { wch: max_width }, {wch: 20},   {wch: 20},         {wch: 15},      {wch: 15},  {wch: 30},  {wch: 15},       {wch: 15}   , {wch: 15}, {wch: 15} , {wch: 15}   ,       {wch: 15}    ,  {wch: 15}   , {wch: 15} , {wch: 10}, {wch: 15} ];
        } else {



ws["!cols"] = [
            //  'Leitzeichen',
            { wch: max_width },
            //'Name des Standortes',
            {wch: 20},
            // 'Standortkategorie',
            {wch: 20},
            // Bewohnergruppen
            {wch: 18},
            // Bezirk
            {wch: 16},
            //Addresse: x.address,
            {wch: 20},
            //Ansprechperson: x.contactPerson,
            {wch: 20},
            // Telefon: x.phoneNumber,
            {wch: 16},
            //Email: x.email,
            {wch: 17},
            // TL: x.tl,
            {wch: 16},
            //BL: x.bl,
            {wch: 16},
            //Belegungsstart: formattedDate(x.startOfOccupancy),
            {wch: 15},
            //Belegungsende:  formattedDate(x.endOfOccupancy),
            {wch: 15},
            // 'Anzahl Ist-Belegung Ukrainer' : x.numberOfOccupiedUkr,
            {wch: 15},
            // 'Anzahl Ist-Belegung örU': x.numberOfOccupiedOru,
            {wch: 15},
            // 'Anzahl freie Plätze': x.numberOfAvailablePlaces,
            {wch: 15},
            // 'Anzahl reservierter Plätze': x.numberOfReservedSeats,
            {wch: 15},
            // 'Anzahl nicht belegbare Plätze': x.numberOfUnoccupiedSeats,
            {wch: 15},
            // whyNotAssignable : x.whyNotAssignable,
            {wch: 20},
            // 'Anzahl Einzelzimmer (w/m/d)':x.singleRoomFMD,
            {wch: 15},
            // 'text_SingleRoomFMD' : x.text_SingleRoomFMD,
            {wch: 15},
            // 'Anzahl Platz in bereits belegtem Zimmer w' : x.feedSlotW,
            {wch: 15},
            // 'Anmerkungen zu einem bereits belegtem Zimmer w': x.text_FeedSlotW,
            {wch: 20},
            // 'Anzahl Platz in bereits belegtem Zimmer m': x.feedSlotM,
            {wch: 15},
            // 'Anmerkungen zu einem bereits belegtem Zimmer m': x.text_FeedSlotM,
            {wch: 20},
            // '2er' : x.roomForTwo,
            {wch: 15},
            // 'Anmerkungen zur 2-Zimmer': x.text_RoomForTwo,
            {wch: 20},
            // '3er' :x.roomForThree,
            {wch: 15},
            // 'Anmerkungen zur 3-Zimmer': x.text_RoomForThree,
            {wch: 20},
            // '4er': x.roomForFour,
            {wch: 15},
            // 'Anmerkungen zur 4-Zimmer': x.text_RoomForFour,
            {wch: 20},
            // '5er': x.roomForFive,
            {wch: 15},
            // 'Anmerkungen zur 5-Zimmer': x.text_RoomForFive,
            {wch: 20},
            // '6er': x.roomForSix,
            {wch: 15},
            // 'Anmerkungen zur 6-Zimmer': x.text_RoomForSix,
            {wch: 20},
            // '7er': x.roomForSeven,
            {wch: 15},
            // 'Anmerkungen zur 7-Zimmer': x.text_RoomForSeven,
            {wch: 20},
            // '8er' : x.roomForEight,
            {wch: 15},
            // 'Anmerkungen zur 8-Zimmer': x.text_RoomForEight,
            {wch: 20},
            // '9er' : x.roomForNine,
            {wch: 15},
            // 'Anmerkungen zur 9-Zimmer': x.text_RoomForNine,
            {wch: 20},
            // '10er': x.roomForTen,
            {wch: 15},
            // 'Anmerkungen zur 10-Zimmer': x.text_RoomForTen,
            {wch: 20},
            // 'Belegungshinweise zu den Plätzen': x.notesOnAccommodation
            {wch: 15}

                ];
        }






        //const ws = XLSX.utils.json_to_sheet(csvData);
        //const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});

        FileSaver.saveAs(data, fileName + fileExtension);

}